import { render, staticRenderFns } from "./TextConfig.vue?vue&type=template&id=24c667a8&scoped=true"
import script from "./TextConfig.vue?vue&type=script&lang=js"
export * from "./TextConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24c667a8",
  null
  
)

export default component.exports